// import React, { useEffect, useRef } from 'react';
// import { Mic, MicOff, Signal, SignalLow, SignalMedium, Video, VideoOff } from 'lucide-react';
// import { AudioVisualizer } from './AudioVisualizer';

// interface Participant {
//   id: string;
//   name: string;
//   permissions: {
//     isHost: boolean;
//   };
//   isScreenSharing?: boolean;
// }

// interface ParticipantListProps {
//   participants: Participant[];
//   currentUserId: string;
//   rtkMeeting: any;
//   backendToRtkIdMap: Map<string, string>;
//   onMuteParticipant?: (participantId: string) => void;
//   audioLevels?: Map<string, number>;
//   connectionQuality?: Map<string, 'excellent' | 'good' | 'poor'>;
//   isHost?: boolean;
// }

// const ParticipantAudio: React.FC<{ audioTrack: MediaStreamTrack | undefined }> = ({ audioTrack }) => {
//   const audioRef = useRef<HTMLAudioElement>(null);

//   useEffect(() => {
//     const audioElement = audioRef.current;
//     if (!audioElement) return;

//     if (audioTrack) {
//       const stream = audioElement.srcObject as MediaStream;
//       if (!stream || stream.getAudioTracks()[0]?.id !== audioTrack.id) {
//         const newStream = new MediaStream([audioTrack]);
//         audioElement.srcObject = newStream;
//         audioElement.play().catch(error => {
//           console.error(`Audio play failed: ${error.message}`);
//         });
//       }
//     } else {
//       audioElement.srcObject = null;
//     }
//   }, [audioTrack]);

//   return <audio ref={audioRef} autoPlay playsInline controls={false} style={{ display: 'none' }} />;
// };

// const ParticipantVideo: React.FC<{
//   videoTrack: MediaStreamTrack | undefined;
//   participantName: string;
//   isVideoEnabled: boolean;
// }> = ({ videoTrack, participantName, isVideoEnabled }) => {
//   const videoRef = useRef<HTMLVideoElement>(null);

//   useEffect(() => {
//     const videoElement = videoRef.current;
//     if (!videoElement) return;

//     if (videoTrack && isVideoEnabled) {
//       const stream = videoElement.srcObject as MediaStream;
//       if (!stream || stream.getVideoTracks()[0]?.id !== videoTrack.id) {
//         const newStream = new MediaStream([videoTrack]);
//         videoElement.srcObject = newStream;
//         videoElement.play().catch(error => {
//           console.error(`Video play failed: ${error.message}`);
//         });
//       }
//     } else {
//       videoElement.srcObject = null;
//     }
//   }, [videoTrack, isVideoEnabled]);

//   return (
//     <div className="relative w-full aspect-video bg-neutral-900 rounded-lg overflow-hidden">
//       {isVideoEnabled && videoTrack ? (
//         <video
//           ref={videoRef}
//           autoPlay
//           playsInline
//           muted
//           className="w-full h-full object-cover"
//         />
//       ) : (
//         <div className="w-full h-full flex items-center justify-center">
//           <div className="w-16 h-16 rounded-full bg-neutral-700 flex items-center justify-center text-2xl font-semibold text-neutral-300">
//             {participantName.charAt(0).toUpperCase()}
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export const ParticipantList: React.FC<ParticipantListProps> = ({
//   participants,
//   currentUserId,
//   rtkMeeting,
//   backendToRtkIdMap,
//   onMuteParticipant,
//   audioLevels = new Map(),
//   connectionQuality = new Map(),
//   isHost = false,
// }) => {
//   const getSignalIcon = (quality: string) => {
//     switch (quality) {
//       case 'excellent':
//         return <Signal size={16} className="text-accent-400" />;
//       case 'good':
//         return <SignalMedium size={16} className="text-yellow-400" />;
//       case 'poor':
//         return <SignalLow size={16} className="text-red-400" />;
//       default:
//         return <Signal size={16} className="text-neutral-500" />;
//     }
//   };

//   const getAudioState = (participantId: string) => {
//     const rtkId = backendToRtkIdMap.get(participantId);
//     const isSelf = rtkMeeting?.self?.id === rtkId;

//     if (isSelf) {
//       const audioLevel = audioLevels.get(rtkId || '') || 0;
//       const isAudioEnabled = rtkMeeting.self?.audioEnabled || false;
//       const isSpeaking = audioLevel > 0.01 && isAudioEnabled;
//       return { isAudioEnabled, isSpeaking };
//     }

//     if (!rtkId || !rtkMeeting?.participants?.joined) {
//       return { isAudioEnabled: false, isSpeaking: false };
//     }

//     const rtkParticipant = rtkMeeting.participants.joined.get(rtkId);
//     const audioLevel = audioLevels.get(rtkId) || 0;
//     const isAudioEnabled = rtkParticipant?.audioEnabled || false;
//     const isSpeaking = audioLevel > 0.01 && isAudioEnabled;

//     return { isAudioEnabled, isSpeaking };
//   };

//   const getVideoState = (participantId: string) => {
//     const rtkId = backendToRtkIdMap.get(participantId);
//     const isSelf = rtkMeeting?.self?.id === rtkId;

//     if (isSelf) {
//       return rtkMeeting.self?.videoEnabled || false;
//     }

//     if (!rtkId || !rtkMeeting?.participants?.joined) {
//       return false;
//     }

//     const rtkParticipant = rtkMeeting.participants.joined.get(rtkId);
//     return rtkParticipant?.videoEnabled || false;
//   };

//   return (
//     <div>
//       <h3 className="text-sm font-semibold mb-3 text-white">
//         Participants ({participants?.length})
//       </h3>
//       <div className="space-y-3">
//         {participants?.map((participant) => {
//           const isCurrentUser = participant.id === currentUserId;
//           const rtkId = backendToRtkIdMap.get(participant.id);
//           const quality = connectionQuality.get(rtkId || '') || 'good';
//           const { isAudioEnabled } = getAudioState(participant.id);
//           const isVideoEnabled = getVideoState(participant.id);

//           const audioTrack = isCurrentUser
//             ? rtkMeeting?.self?.audioTrack
//             : rtkMeeting?.participants?.joined?.get(rtkId)?.audioTrack;

//           const videoTrack = isCurrentUser
//             ? rtkMeeting?.self?.videoTrack
//             : rtkMeeting?.participants?.joined?.get(rtkId)?.videoTrack;

//           return (
//             <div key={participant.id} className={`rounded-lg overflow-hidden transition-all ${isCurrentUser
//               ? 'bg-primary-500/20 border border-primary-500/30'
//               : 'bg-white/5 border border-white/10'
//               }`}>
//               {/* Video Container */}
//               <ParticipantVideo
//                 videoTrack={videoTrack}
//                 participantName={participant.name}
//                 isVideoEnabled={isVideoEnabled}
//               />

//               {/* Info Bar */}
//               <div className="flex items-center justify-between p-3">
//                 <div className="flex items-center gap-3 flex-1 min-w-0">
//                   {/* Avatar with audio visualizer (shown when video is off) */}
//                   {!isVideoEnabled && (
//                     <div className="relative">
//                       <div className="w-9 h-9 rounded-full flex items-center justify-center text-sm font-semibold bg-neutral-700 text-neutral-300">
//                         {participant.name.charAt(0).toUpperCase()}
//                       </div>
//                       {audioTrack && <AudioVisualizer audioTrack={audioTrack} />}
//                     </div>
//                   )}

//                   {/* Name & Status */}
//                   <div className="flex-1 min-w-0">
//                     <p className="text-sm font-medium text-white truncate">
//                       {participant.name}
//                       {isCurrentUser && (
//                         <span className="ml-1.5 text-xs text-primary-400">(You)</span>
//                       )}
//                       {participant.permissions.isHost && (
//                         <span className="ml-1.5 text-xs text-secondary-400">(Host)</span>
//                       )}
//                     </p>
//                     {participant.isScreenSharing && (
//                       <p className="text-xs text-neutral-400 mt-0.5">Sharing screen</p>
//                     )}
//                   </div>
//                 </div>

//                 {/* Controls */}
//                 <div className="flex items-center gap-2">
//                   {/* Connection quality */}
//                   {getSignalIcon(quality)}

//                   {/* Video status */}
//                   <div title={isVideoEnabled ? 'Camera on' : 'Camera off'}>
//                     {isVideoEnabled ? (
//                       <Video size={16} className="text-neutral-400" />
//                     ) : (
//                       <VideoOff size={16} className="text-neutral-600" />
//                     )}
//                   </div>

//                   {/* Host mute button for OTHER participants only */}
//                   {!isCurrentUser && isHost && onMuteParticipant && (
//                     <button
//                       onClick={() => onMuteParticipant(participant.id)}
//                       className={`p-1.5 rounded transition-all ${isAudioEnabled
//                         ? 'hover:bg-red-500/20 text-neutral-400 hover:text-red-400'
//                         : 'text-neutral-600 cursor-not-allowed'
//                         }`}
//                       title={isAudioEnabled ? 'Mute participant' : 'Already muted'}
//                       disabled={!isAudioEnabled}
//                     >
//                       {isAudioEnabled ? (
//                         <Mic size={16} />
//                       ) : (
//                         <MicOff size={16} />
//                       )}
//                     </button>
//                   )}

//                   {/* Status indicator for everyone (read-only) */}
//                   {(!isHost || isCurrentUser) && (
//                     <div title={isAudioEnabled ? 'Mic on' : 'Muted'}>
//                       {isAudioEnabled ? (
//                         <Mic size={16} className="text-neutral-400" />
//                       ) : (
//                         <MicOff size={16} className="text-red-400" />
//                       )}
//                     </div>
//                   )}
//                 </div>
//               </div>

//               {/* Audio playback for remote participants */}
//               {!isCurrentUser && (
//                 <ParticipantAudio
//                   key={`audio-${rtkId}`}
//                   audioTrack={audioTrack}
//                 />
//               )}
//             </div>
//           );
//         })}
//       </div>
//     </div>
//   );
// }

import React, { useEffect, useRef } from 'react';
import { Mic, MicOff, Signal, SignalLow, SignalMedium, Video, VideoOff } from 'lucide-react';
import { AudioVisualizer } from './AudioVisualizer';

interface Participant {
  id: string;
  name: string;
  permissions: {
    isHost: boolean;
  };
  isScreenSharing?: boolean;
}

interface ParticipantListProps {
  participants: Participant[];
  currentUserId: string;
  rtkMeeting: any;
  backendToRtkIdMap: Map<string, string>;
  onMuteParticipant?: (participantId: string) => void;
  audioLevels?: Map<string, number>;
  connectionQuality?: Map<string, 'excellent' | 'good' | 'poor'>;
  isHost?: boolean;
  viewMode?: 'list' | 'grid'; // NEW: Toggle between sidebar list and full grid
}

const ParticipantAudio: React.FC<{ audioTrack: MediaStreamTrack | undefined }> = ({ audioTrack }) => {
  const audioRef = useRef<HTMLAudioElement>(null);

  useEffect(() => {
    const audioElement = audioRef.current;
    if (!audioElement) return;

    if (audioTrack) {
      const stream = audioElement.srcObject as MediaStream;
      if (!stream || stream.getAudioTracks()[0]?.id !== audioTrack.id) {
        const newStream = new MediaStream([audioTrack]);
        audioElement.srcObject = newStream;
        audioElement.play().catch(error => {
          console.error(`Audio play failed: ${error.message}`);
        });
      }
    } else {
      audioElement.srcObject = null;
    }
  }, [audioTrack]);

  return <audio ref={audioRef} autoPlay playsInline controls={false} style={{ display: 'none' }} />;
};

const ParticipantVideo: React.FC<{
  videoTrack: MediaStreamTrack | undefined;
  participantName: string;
  isVideoEnabled: boolean;
}> = ({ videoTrack, participantName, isVideoEnabled }) => {
  const videoRef = useRef<HTMLVideoElement>(null);

  useEffect(() => {
    const videoElement = videoRef.current;
    if (!videoElement) return;

    if (videoTrack && isVideoEnabled) {
      const stream = videoElement.srcObject as MediaStream;
      if (!stream || stream.getVideoTracks()[0]?.id !== videoTrack.id) {
        const newStream = new MediaStream([videoTrack]);
        videoElement.srcObject = newStream;
        videoElement.play().catch(error => {
          console.error(`Video play failed: ${error.message}`);
        });
      }
    } else {
      videoElement.srcObject = null;
    }
  }, [videoTrack, isVideoEnabled]);

  return (
    <div className="relative w-full aspect-video bg-neutral-900 rounded-lg overflow-hidden">
      {isVideoEnabled && videoTrack ? (
        <video
          ref={videoRef}
          autoPlay
          playsInline
          muted
          className="w-full h-full object-cover"
        />
      ) : (
        <div className="w-full h-full flex items-center justify-center">
          <div className="w-16 h-16 rounded-full bg-neutral-700 flex items-center justify-center text-2xl font-semibold text-neutral-300">
            {participantName.charAt(0).toUpperCase()}
          </div>
        </div>
      )}
    </div>
  );
};

export const ParticipantList: React.FC<ParticipantListProps> = ({
  participants,
  currentUserId,
  rtkMeeting,
  backendToRtkIdMap,
  onMuteParticipant,
  audioLevels = new Map(),
  connectionQuality = new Map(),
  isHost = false,
  viewMode = 'list', // Default to list view
}) => {
  const getSignalIcon = (quality: string) => {
    switch (quality) {
      case 'excellent':
        return <Signal size={16} className="text-accent-400" />;
      case 'good':
        return <SignalMedium size={16} className="text-yellow-400" />;
      case 'poor':
        return <SignalLow size={16} className="text-red-400" />;
      default:
        return <Signal size={16} className="text-neutral-500" />;
    }
  };

  const getAudioState = (participantId: string) => {
    const rtkId = backendToRtkIdMap.get(participantId);
    const isSelf = rtkMeeting?.self?.id === rtkId;

    if (isSelf) {
      const audioLevel = audioLevels.get(rtkId || '') || 0;
      const isAudioEnabled = rtkMeeting.self?.audioEnabled || false;
      const isSpeaking = audioLevel > 0.01 && isAudioEnabled;
      return { isAudioEnabled, isSpeaking };
    }

    if (!rtkId || !rtkMeeting?.participants?.joined) {
      return { isAudioEnabled: false, isSpeaking: false };
    }

    const rtkParticipant = rtkMeeting.participants.joined.get(rtkId);
    const audioLevel = audioLevels.get(rtkId) || 0;
    const isAudioEnabled = rtkParticipant?.audioEnabled || false;
    const isSpeaking = audioLevel > 0.01 && isAudioEnabled;

    return { isAudioEnabled, isSpeaking };
  };

  const getVideoState = (participantId: string) => {
    const rtkId = backendToRtkIdMap.get(participantId);
    const isSelf = rtkMeeting?.self?.id === rtkId;

    if (isSelf) {
      return rtkMeeting.self?.videoEnabled || false;
    }

    if (!rtkId || !rtkMeeting?.participants?.joined) {
      return false;
    }

    const rtkParticipant = rtkMeeting.participants.joined.get(rtkId);
    return rtkParticipant?.videoEnabled || false;
  };

  // Calculate grid layout based on participant count
  const getGridCols = (count: number) => {
    if (count === 1) return 'grid-cols-1';
    if (count === 2) return 'grid-cols-1 md:grid-cols-2';
    if (count <= 4) return 'grid-cols-2';
    if (count <= 6) return 'grid-cols-2 md:grid-cols-3';
    if (count <= 9) return 'grid-cols-2 md:grid-cols-3 lg:grid-cols-3';
    return 'grid-cols-2 md:grid-cols-3 lg:grid-cols-4';
  };

  const participantCount = participants?.length || 0;

  // GRID MODE: Show participants in responsive grid (Google Meet style)
  if (viewMode === 'grid') {
    return (
      <div className="h-full w-full overflow-y-auto">
        <div className={`grid ${getGridCols(participantCount)} gap-4 auto-rows-fr w-full`}>
          {participants?.map((participant) => {
            const isCurrentUser = participant.id === currentUserId;
            const rtkId = backendToRtkIdMap.get(participant.id);
            const quality = connectionQuality.get(rtkId || '') || 'good';
            const { isAudioEnabled } = getAudioState(participant.id);
            const isVideoEnabled = getVideoState(participant.id);

            const audioTrack = isCurrentUser
              ? rtkMeeting?.self?.audioTrack
              : rtkMeeting?.participants?.joined?.get(rtkId)?.audioTrack;

            const videoTrack = isCurrentUser
              ? rtkMeeting?.self?.videoTrack
              : rtkMeeting?.participants?.joined?.get(rtkId)?.videoTrack;

            return (
              <div key={participant.id} className="min-h-[200px] md:min-h-[250px]">
                <div className={`h-full rounded-lg overflow-hidden transition-all ${isCurrentUser
                    ? 'bg-primary-500/20 border-2 border-primary-500/50'
                    : 'bg-white/5 border border-white/10'
                  }`}>
                  {/* Video Container */}
                  <ParticipantVideo
                    videoTrack={videoTrack}
                    participantName={participant.name}
                    isVideoEnabled={isVideoEnabled}
                  />

                  {/* Info Bar - Compact for grid */}
                  <div className="flex items-center justify-between p-2 bg-black/40 backdrop-blur-sm">
                    <div className="flex items-center gap-2 flex-1 min-w-0">
                      {!isVideoEnabled && (
                        <div className="relative">
                          <div className="w-8 h-8 rounded-full flex items-center justify-center text-xs font-semibold bg-neutral-700 text-neutral-300">
                            {participant.name.charAt(0).toUpperCase()}
                          </div>
                          {audioTrack && <AudioVisualizer audioTrack={audioTrack} />}
                        </div>
                      )}

                      <div className="flex-1 min-w-0">
                        <p className="text-sm font-medium text-white truncate">
                          {participant.name}
                          {isCurrentUser && (
                            <span className="ml-1 text-xs text-primary-400">(You)</span>
                          )}
                          {participant.permissions.isHost && (
                            <span className="ml-1 text-xs text-secondary-400">(Host)</span>
                          )}
                        </p>
                      </div>
                    </div>

                    {/* Compact Controls */}
                    <div className="flex items-center gap-1.5">
                      {getSignalIcon(quality)}
                      {isVideoEnabled ? (
                        <Video size={14} className="text-neutral-400" />
                      ) : (
                        <VideoOff size={14} className="text-neutral-600" />
                      )}
                      {isAudioEnabled ? (
                        <Mic size={14} className="text-neutral-400" />
                      ) : (
                        <MicOff size={14} className="text-red-400" />
                      )}
                    </div>
                  </div>

                  {/* Audio playback */}
                  {!isCurrentUser && (
                    <ParticipantAudio
                      key={`audio-${rtkId}`}
                      audioTrack={audioTrack}
                    />
                  )}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    );
  }

  // LIST MODE: Original sidebar layout
  return (
    <div>
      <h3 className="text-sm font-semibold mb-3 text-white">
        Participants ({participantCount})
      </h3>
      <div className="space-y-3">
        {participants?.map((participant) => {
          const isCurrentUser = participant.id === currentUserId;
          const rtkId = backendToRtkIdMap.get(participant.id);
          const quality = connectionQuality.get(rtkId || '') || 'good';
          const { isAudioEnabled } = getAudioState(participant.id);
          const isVideoEnabled = getVideoState(participant.id);

          const audioTrack = isCurrentUser
            ? rtkMeeting?.self?.audioTrack
            : rtkMeeting?.participants?.joined?.get(rtkId)?.audioTrack;

          const videoTrack = isCurrentUser
            ? rtkMeeting?.self?.videoTrack
            : rtkMeeting?.participants?.joined?.get(rtkId)?.videoTrack;

          return (
            <div key={participant.id} className={`rounded-lg overflow-hidden transition-all ${isCurrentUser
                ? 'bg-primary-500/20 border border-primary-500/30'
                : 'bg-white/5 border border-white/10'
              }`}>
              {/* Video Container */}
              <ParticipantVideo
                videoTrack={videoTrack}
                participantName={participant.name}
                isVideoEnabled={isVideoEnabled}
              />

              {/* Info Bar */}
              <div className="flex items-center justify-between p-3">
                <div className="flex items-center gap-3 flex-1 min-w-0">
                  {!isVideoEnabled && (
                    <div className="relative">
                      <div className="w-9 h-9 rounded-full flex items-center justify-center text-sm font-semibold bg-neutral-700 text-neutral-300">
                        {participant.name.charAt(0).toUpperCase()}
                      </div>
                      {audioTrack && <AudioVisualizer audioTrack={audioTrack} />}
                    </div>
                  )}

                  <div className="flex-1 min-w-0">
                    <p className="text-sm font-medium text-white truncate">
                      {participant.name}
                      {isCurrentUser && (
                        <span className="ml-1.5 text-xs text-primary-400">(You)</span>
                      )}
                      {participant.permissions.isHost && (
                        <span className="ml-1.5 text-xs text-secondary-400">(Host)</span>
                      )}
                    </p>
                    {participant.isScreenSharing && (
                      <p className="text-xs text-neutral-400 mt-0.5">Sharing screen</p>
                    )}
                  </div>
                </div>

                {/* Controls */}
                <div className="flex items-center gap-2">
                  {getSignalIcon(quality)}

                  <div title={isVideoEnabled ? 'Camera on' : 'Camera off'}>
                    {isVideoEnabled ? (
                      <Video size={16} className="text-neutral-400" />
                    ) : (
                      <VideoOff size={16} className="text-neutral-600" />
                    )}
                  </div>

                  {!isCurrentUser && isHost && onMuteParticipant && (
                    <button
                      onClick={() => onMuteParticipant(participant.id)}
                      className={`p-1.5 rounded transition-all ${isAudioEnabled
                          ? 'hover:bg-red-500/20 text-neutral-400 hover:text-red-400'
                          : 'text-neutral-600 cursor-not-allowed'
                        }`}
                      title={isAudioEnabled ? 'Mute participant' : 'Already muted'}
                      disabled={!isAudioEnabled}
                    >
                      {isAudioEnabled ? (
                        <Mic size={16} />
                      ) : (
                        <MicOff size={16} />
                      )}
                    </button>
                  )}

                  {(!isHost || isCurrentUser) && (
                    <div title={isAudioEnabled ? 'Mic on' : 'Muted'}>
                      {isAudioEnabled ? (
                        <Mic size={16} className="text-neutral-400" />
                      ) : (
                        <MicOff size={16} className="text-red-400" />
                      )}
                    </div>
                  )}
                </div>
              </div>

              {/* Audio playback */}
              {!isCurrentUser && (
                <ParticipantAudio
                  key={`audio-${rtkId}`}
                  audioTrack={audioTrack}
                />
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};